export default __webpack_public_path__ + "static/media/halfcycle.b12b34da.png";